module.exports = "<template>\n    <section>\n        <b-button @click=\"clickMe\">Click Me</b-button>\n    </section>\n</template>\n\n<script>\n    export default {\n        methods: {\n            clickMe() {\n                this.$buefy.notification.open('Clicked!!')\n            }\n        }\n    }\n</script>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./docs/pages/components/button/examples/ExSimple.vue
// module id = 1319
// module chunks = 21